import { fetchSignUpData } from "@/service/auth";
import { ElNotification } from "element-plus";

export default {
  data() {
    return {
      registerForm: {
        name: '',
        username: '',
        password: '',
        // confirmPassword: ''
      },
      captchaVisible: true,
      registerProcessing: false,
      errorMsg: null,
      registerRules: {
        name: [{ required: true, message: 'Name is required', trigger: 'blur' }],
        username: [{ required: true, message: 'Username is required', trigger: 'blur' }],
        password: [
          { required: true, message: 'Password is required', trigger: 'blur' },
          {
            pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
            message: 'Password must have 8+ chars, 1 letter, 1 number, 1 special char',
            trigger: 'blur',
          },
        ],
        confirmPassword: [
          { required: true, message: 'Confirm password is required', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.registerForm.password) {
                callback(new Error('Passwords do not match!'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
    };
  },

  methods: {
    showNotification(type, title, message) {
      ElNotification({
        type,
        title,
        message,
        duration: 3000,
      });
    },

    async handleRegister() {
      console.log("handleRegister function triggered");
    
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          console.warn("Form validation failed");
          return;
        }
    
        if (this.registerForm.password !== this.registerForm.confirmPassword) {
          console.log("Passwords do not match! Showing notification...");
          this.showNotification("error", "Registration Failed", "Passwords do not match!");
          return;
        }
    
        this.registerProcessing = true;
        this.errorMsg = null;
    
        try {
          const params = {
            name: this.registerForm.name,
            username: this.registerForm.username,
            password: this.registerForm.password,
          };
    
          console.log("Sending request with params:", params);
          const result = await fetchSignUpData(params);
    
          if (result?.data?.success) {
            setTimeout(() => {
              this.$router.push({ name: "login-page" });
            }, 1500);
          } else {
            this.errorMsg = result?.data?.message;
            this.showNotification("success", "Registration Successful");
          }
    
        } catch (error) {
          console.error("API Error:", error);
          this.errorMsg = error?.response?.data?.message || "User Already Exists";
          this.showNotification("error", "Registration Error", this.errorMsg);
        } finally {
          this.registerProcessing = false;
        }
      });
    }
    
  }
};